import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";
import { StyledSignalTypeWrap } from "../SignalType/styles";

export const StyledSignalTypesList = styled.div`
    background-color: ${colorsPalettes.carbon["25"]};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    box-sizing: border-box;
    flex-grow: 0;
    flex-shrink: 0;
    margin-top: 20px;
    min-width: 183px;
    padding: 8px;

    & ${StyledSignalTypeWrap}:not(:first-child) {
        margin-top: 4px;
    }
`;
